import type { AuthData, User } from '../types';

const AUTH_KEY = 'auth';

export const getAuth = (): AuthData | null => {
  const authStr = localStorage.getItem(AUTH_KEY);
  if (!authStr) return null;
  try {
    return JSON.parse(authStr);
  } catch {
    return null;
  }
};

export const setAuth = (auth: AuthData): void => {
  localStorage.setItem(AUTH_KEY, JSON.stringify(auth));
};

export const clearAuth = (): void => {
  localStorage.removeItem(AUTH_KEY);
};

export const getUser = (): User | null => {
  const auth = getAuth();
  return auth?.user || null;
};

export const isAuthenticated = (): boolean => {
  return getAuth() !== null;
};

export const getAccessToken = (): string | null => {
  const auth = getAuth();
  return auth?.access_token || null;
};

export const getRefreshToken = (): string | null => {
  const auth = getAuth();
  return auth?.refresh_token || null;
};

export const updateTokens = (accessToken: string, refreshToken: string, user?: AuthData['user']): void => {
  const auth = getAuth();
  if (auth) {
    auth.access_token = accessToken;
    auth.refresh_token = refreshToken;
    if (user) {
      auth.user = user;
    }
    setAuth(auth);
  }
};

export const hasRole = (roles: string[]): boolean => {
  const user = getUser();
  if (!user) return false;

  // Check isSuperAdmin flag for super_admin role
  if (roles.includes('super_admin') && user.isSuperAdmin) {
    return true;
  }

  // Check role.systemKey for other roles
  return roles.includes(user.role?.systemKey || '');
};
